import { Coord } from "../../../../../../../../../src/types/Interface";


export default function getNumberConCoords(lineCoords: { originCoord: Coord, endCoords: Coord[] }, cellSize: number): Coord[][] {
  return lineCoords.endCoords.map(coord => {
    const delta = {
      width: coord.x - lineCoords.originCoord.x,
      height: coord.y - lineCoords.originCoord.y
    };
    const unitdim = { x: delta.width / cellSize, y: delta.height / cellSize }
    const totalUnit = Math.abs((delta.width + delta.height) / cellSize) || 0;

    return Array(totalUnit)
      .fill("")
      .map((_, i) => {
        const size = (i + 1) * cellSize;
        return {
          x: (unitdim.x == 0 ? -30 : (unitdim.x / Math.abs(unitdim.x)) * size) + lineCoords.originCoord.x,
          y: (unitdim.y == 0 ? 30 : (unitdim.y / Math.abs(unitdim.y)) * size) + lineCoords.originCoord.y
        }
      })
  })
}